import {
  SR_API_ACTION_UPDATE_USER_QUESTION_STATUS,
} from 'api/actionTypes';

import typeCheck from 'common/util/typeCheck';

export default async function applyUserQuestionStatusChange({ state, apiClient }, payload) {
  const {
    userQuestionId,
    entityTransitionUpdates,
    questionStatus,
  } = payload;

  typeCheck('userQuestionId::PositiveNumber', userQuestionId);
  typeCheck('questionStatus::String', questionStatus);
  typeCheck('entityTransitionUpdates::Maybe Object', entityTransitionUpdates);

  await apiClient.postWithState({
    action: SR_API_ACTION_UPDATE_USER_QUESTION_STATUS,
    queryId: String(userQuestionId),
    state: state,
    payload: {
      userQuestionId,
      entityTransitionUpdates,
      questionStatus,
    },
  });
}
